<div class="table mt-0100"
     *ngIf="entity">

  <!--Menu Button Template-->
  <mat-menu class="popover__menu ignore-click"
            #phoneMenu="matMenu">
    <ng-template matMenuContent
                 let-social="social">
      <ng-container *ngIf="isBad(social); then badButtons else goodButtons">
      </ng-container>

      <ng-template #badButtons>
        <button mat-menu-item
                (click)="onSetStatus(social, 'user_added')">
          <span class="link link--green link--noline">Restore</span>
        </button>
      </ng-template>

      <ng-template #goodButtons>

        <button mat-menu-item
                (click)="onEdit(social)">Edit
        </button>
        <button mat-menu-item
                *ngIf="!isVerified(social)"
                (click)="onSetStatus(social, 'verified')">
          <span class="link link--green link--noline">Mark as Confirmed</span>
        </button>
        <button mat-menu-item
                *ngIf="isVerified(social)"
                (click)="onSetStatus(social, 'user_added')">
          Unmark As Confirmed
        </button>

        <button mat-menu-item
                (click)="onSetStatus(social, 'bad')">
          <span class="link link--noline link--red"
                data-test-id="markAsBad">Mark as bad</span>
        </button>
      </ng-template>
    </ng-template>
  </mat-menu>


  <div class="tr tr--noGutter tile__heading pt-0 pb-0">
    Social Media Profiles
    <ng-container *ngIf="showTaskDoneMark">
      <span class="color--gray ml-0050">
        &bull;
        <span class="color--green">
          <span class="d-none d-inline--md uppercase ml-0025">Done</span>
          <i class="far fa-check ml-0025"></i>
        </span>
      </span>
    </ng-container>
    <button mat-button
            disableRipple
            class="addNew ml-auto mat-button--no-focus-overlay"
            (click)="onAddNew()">
      <i class="far fa-plus addNew__icon"></i>
      Add
    </button>
  </div>

  <div class="tr trContact"
       *ngFor="let social of sortByLabel(socialHandles,showBad)"
       [ngClass]="{'tr--red': isBad(social)}">
    <div class="tc trContact__title">
      <a class="link link--blue link--noline"
         target="_blank"
         [attr.href]="getSocialURL(social)">
        <i class="pr-0025 {{social.socialNetwork.icon}}"></i>
        {{getSocialLabel(social)}}</a>
      <i *ngIf="social.status === 'verified'"
         class="far fa-check pair__verified ml-0050"
         matTooltip="Confirmed"
         matTooltipPosition="above"></i>
      <i class="far fa-times-circle pair__red ml-0050"
         *ngIf="isBad(social)"
         matTooltip="Marked as Bad"
         matTooltipPosition="above"></i>
    </div>


    <div class="tc tc--xs trContact__type">
      {{social.socialNetwork.label}}</div>

    <div class="tc tc--xs trContact__type">{{social.source | source}}</div>

    <div class="tc tc--light tc--xs trContact__meta">Edited {{social.updatedAt | relativeDate}}</div>

    <div class="tr__drawer tr__drawer--sm drawer">
      <button class="drawer__btn"
              type="button"
              [matMenuTriggerFor]="phoneMenu"
              [matMenuTriggerData]="{social}">
        <i class="far fa-fw fa-ellipsis-h fa--gray"></i>
      </button>
    </div>
  </div>

  <div class="tr tr--noGutter tr--sm tr--gray"
       *ngIf="getBadCount(entity.socialProfiles) > 0">
    <div class="addNew addNew--red ml-auto mr-0025"
         (click)="showBad = !showBad"
         data-test-id="togglePhoneShowBad">
      <ng-container *ngIf="!showBad">
        <span class="addNew__text">
          View Bad (<strong data-test-id="phoneBadCount">{{getBadCount(entity.socialProfiles)}}</strong>)
        </span>
        <i class="far fa-chevron-down ml-0050 addNew__text--gray"></i>
      </ng-container>
      <ng-container *ngIf="showBad">
        <span class="addNew__text">
          Hide Bad (<strong data-test-id="phoneBadCount">{{getBadCount(entity.socialProfiles)}}</strong>)
        </span>
        <i class="far fa-chevron-up ml-0050 addNew__text--gray"></i>
      </ng-container>
    </div>
  </div>
</div>
